import React from 'react';

import styles from './index.module.css';

export default ({fit = false}) => {
  const labelStyles = fit ? styles.fitLoader : styles.loader;

  return (
    <div className={labelStyles}>
      <div className={styles.spin} />
    </div>
  );
};
